module.exports = __webpack_public_path__ + "img/login-bg-icon.2fd2297b.svg";